var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 8,
    viewBox: "0 0 7 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.35694 3.67063C6.41508 3.70733 6.46262 3.75644 6.49546 3.81372C6.5283 3.871 6.54545 3.93475 6.54545 3.99946C6.54545 4.06417 6.5283 4.12791 6.49546 4.1852C6.46262 4.24248 6.41508 4.29158 6.35694 4.32828L0.684608 7.92857C0.619182 7.97024 0.542551 7.99468 0.46304 7.99923C0.383529 8.00377 0.304178 7.98826 0.23361 7.95436C0.163042 7.92047 0.103956 7.86949 0.0627702 7.80697C0.0215846 7.74445 -0.000124942 7.67278 5.40902e-07 7.59974L5.40902e-07 0.399176C0.000328842 0.326308 0.0223175 0.2549 0.0636018 0.192632C0.104886 0.130364 0.163904 0.079592 0.234309 0.0457757C0.304713 0.0119594 0.383841 -0.00362155 0.463182 0.000708374C0.542523 0.0050383 0.619076 0.0291153 0.684608 0.0703501L6.35694 3.67063Z",
    fill: "#494747"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowFill);
export default __webpack_public_path__ + "static/media/arrow-fill.e41770c0bbe2e09a9429cc1b9fa28a56.svg";
export { ForwardRef as ReactComponent };